export default "__VITE_ASSET__CBuI8UPr__"